import Reveal from "../../ui/Reveal";
import Section from "../../ui/Section";
import SectionHeading from "../../ui/SectionHeading";

function ProcessSection({ badge, title, description, steps }) {
  return (
    <Section className="bg-white">
      <SectionHeading badge={badge} title={title} description={description} />

      <div className="relative mt-10 grid gap-5 lg:grid-cols-4">
        <div className="pointer-events-none absolute left-[12.5%] right-[12.5%] top-8 hidden h-[2px] bg-brand-line lg:block" />

        {steps.map((item, index) => (
          <Reveal key={item.step} delay={index * 0.08}>
            <article className="relative h-full rounded-2xl border border-brand-line bg-white p-5 shadow-card transition duration-300 hover:-translate-y-0.5 hover:shadow-card-hover">
              <span className="relative z-10 inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-navy text-sm font-bold text-white">
                {item.step}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-brand-navy">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-charcoal/82">{item.description}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export default ProcessSection;
